module.exports = __webpack_public_path__ + "img/gk_img5.86fbf7e9.png";